<template>
  <div v-if="orderInfo">
    <headerNav title="订单处理" />
    <!-- <van-steps :active="active">
            <van-step>提交订单</van-step>
            <van-step>配送中</van-step>
            <van-step>交易完成</van-step>
        </van-steps> -->

    <!-- <van-cell class="logistics" to="/user/order/logistics/1" title="您的订单已由本人签收（已在配送员处采用无纸化方式签收本订单）。感谢您在京东购物，欢迎再次光临。参加评价还能赢取京豆哟。" label="2018-08-31 21:04:03" icon="logistics" is-link /> -->
    <div class="omain">
      <div class="info newinfo">
        <van-cell-group class="total">
          <van-row class="currow">
            <van-col span="16">{{ "订单：" + orderInfo.tid }}</van-col>
            <van-col span="8" class="curcol">{{
              orderInfo.splitOrderState == 1
                ? orderInfo.deliveryStatus == 1
                  ? "部分发货"
                  : orderInfo.orderStatusEnumName
                : orderInfo.orderStatusEnumName
            }}</van-col>
          </van-row>
          <!-- <div slot="header">
                    <van-cell class="title" :title="'订单：'+orderInfo.tid" :value="orderInfo.orderStatusEnumName" />
                </div> -->
          <div class="currow">
            <div v-for="(product, i) in orderInfo.tradeDetails" :key="i">
              <div class="comcard">
                <div class="comcardinfo">
                  <div class="comimg" @click="goto(product)">
                    <img :src="$baseurl + product.productImageUrl" />
                  </div>
                  <div class="comproduct">
                    <div class="com-header">
                      <div class="com-header-left van-multi-ellipsis--l2">
                        {{ product.productName }}
                      </div>
                      <div class="com-header-right">￥{{ product.price }}</div>
                    </div>
                    <div class="clearboth"></div>
                    <div
                      v-if="product.isSeaProduct"
                      :style="{ color: $abctheme.basecolor }"
                    >
                      【海外产品】
                    </div>
                    <div class="com-main">
                      <span class="com-main-sbg">自发:{{ product.specName }}</span>
                      <span class="com-right">x{{ product.num - product.num2 }}</span>
                    </div>

                    <div class="clearboth"></div>

                    <div v-if="product.cartontexts && product.cartontexts.length > 0">
                      <div
                        v-for="(item, index) in product.cartontexts"
                        :key="index"
                        class="com-main"
                      >
                        <span class="com-main-sbg xg">转公司:{{ item.text }}</span>
                        <span class="com-right">x{{ item.num }}</span>
                      </div>
                    </div>

                    <div class="clearboth"></div>

                    <div v-if="product.num2 > 0">
                      <span class="com-main-sbg xg">转公司:{{ product.specName }}</span>
                      <span class="com-right">x{{ product.num2 }}</span>
                    </div>

                    <div class="specbtns" v-if="!orderInfo.isDisableSelfShip">
                      <van-button
                        v-if="
                          (product.cartonSizeList && product.cartonSizeList.length > 0) ||
                          (product.listNum && product.listNum.length > 0)
                        "
                        @click.stop="trancompany(product)"
                        >转公司</van-button
                      >
                      <van-button
                        
                        @click.stop="cancelnum(product)"
                        >全自发</van-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <van-cell title="商品总额" :value="orderInfo.totalFee" />
                <van-cell title="运费" :value="'+'+orderInfo.postFee" />
                <van-cell title="实付金额" :value="orderInfo.payment" style="font-weight: 700;" /> -->
          <van-cell title="转公司运费" :value="postFee" v-if="postFee" />
          <van-cell title="转公司物料贷款" :value="assestmoney" />
          <van-cell title="转公司大货贷款" :value="bigmoney" />
          <van-cell title="当前物料余额" :value="abp.userInfo.accessoriesLoans" />
          <van-cell title="当前大货余额" :value="abp.userInfo.largeLoans" />
        </van-cell-group>
      </div>

      <!-- <div style="height:15px;"></div>
        <van-cell-group>
            <van-cell title="订单编号" value="18081609422771742" />
            <van-cell title="下单时间" value="2018-08-16 09:42:27" />
            <van-cell title="订单状态" value="配送中" />
        </van-cell-group> -->

      <div class="info footer">
        <div class="munu">
          <!-- <van-button size="small" color="#ff9970" plain round type="primary" v-if="item.isShowCancel" @click.stop="cancel(item)">取消</van-button> -->
          <van-button
            size="large"
            color="#ff9970"
            plain
            round
            type="primary"
            v-if="orderInfo.isShowDeal"
            @click.stop="tranfer()"
            >转单</van-button
          >
        </div>
      </div>
      <van-popup v-model="showtree" position="bottom" close-on-popstate>
        <div class="zten">
          <div class="ztop">
            <div class="btns">
              <van-button @click="cartoncancel">取消</van-button>
              <van-button class="btn-fr" @click="setcartonsize">确定</van-button>
            </div>
            <div class="clearboth"></div>
            <div class="wz">订单数量{{ totalnum }}个,箱规选中总数量{{ curnum }}</div>
          </div>
          <van-tree-select
            v-if="showtree"
            :items="treelist"
            :active-id.sync="activeids"
            :main-active-index.sync="activeindex"
            @click-item="checknum"
          />
        </div>
      </van-popup>

      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          title="选择数量"
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>

      <van-dialog
        v-model="dialogshow"
        @confirm="ordertranfer"
        title="是否进行转单"
        show-cancel-button
      >
        <div class="zproduct">
          <div v-for="(tranfer, index) in tranfereditdto.tranferOrderList" :key="index">
            <div v-if="tranfer.isToCompany" class="ztit">
              <div>转公司单</div>
            </div>
            <div v-else class="ztit">
              <div>自发单</div>
            </div>
            <div v-for="(detail, zindex) in tranfer.tradeDetails" :key="zindex">
              <div class="ztname">
                {{ detail.productName }}
              </div>
              <div v-if="!detail.cartonSize" class="zfr">
                <span>x{{ detail.num - detail.num2 }}</span>
              </div>
              <div v-else class="zfr">
                <span>{{
                  detail.cartonSize +
                  detail.unit +
                  "/" +
                  (detail.num - detail.num2) +
                  "箱"
                }}</span>
              </div>
            </div>
          </div>
          <div class="ztotal">
            <div class="zmtit" v-if="postFee">
                小计运费,共<span class="zprice">￥{{postFee}}</span>元
            </div>
            <div class="zmtit">
              小计物料,共<span class="zprice">￥{{ assestmoney }}</span
              >元
            </div>
            <div class="zmtit">
              小计大货,共<span class="zprice">￥{{ bigmoney }}</span
              >元
            </div>
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import request from "@/config/ajax";
import { Toast } from "vant";
import { Dialog } from "vant";

export default {
  data() {
    return {
      dialogshow: false,
      activeindex: 0,
      treelist: [],
      activeids: [],
      showtree: false,
      curwz: [],
      curcheck: [],
      totalnum: 0,
      curnum: 0, //选中数量
      showPicker: false,
      tid: "",
      columns: [],
      systemsetting: undefined,
      orderInfo: undefined,
      companyorder: undefined,
      paydto: {
        tid: "",
      },
      curitem: {},
      tranfereditdto: {
        tranferOrderList: [],
        tid: "",
      },
      bigmoney: 0,
      assestmoney: 0,
      postFee: 0,
    };
  },
  created() {
    var option = this.$route.query;
    this.tid = option.tid;
    request.post("/api/services/app/SystemSettingFunction/QueryModel").then((x) => {
      this.systemsetting = x.result;
    });
    // this.abp.event.on("app.TranferOrder", x => {
    //     Toast.clear();
    //     if (x.status != 0) {
    //         this.$toast(x.errMsg);
    //     } else {
    //        var tid = x.result;
    //        if(tid=='')
    //        {
    //             this.$router.back(-1);
    //        }
    //        else
    //        {
    //             this.$router.push({
    //                 path: '/pay',
    //                 query: {
    //                     tid: tid,
    //                     code:''
    //                 }
    //             });
    //         }
    //     }
    // })
    this.loaddata();
  },
  methods: {
    loaddata() {
      request
        .post("/api/services/app/PhoneTrade/QueryDealModel", {
          tid: this.tid,
        })
        .then((item) => {
          this.orderInfo = item.result;
          var str = "";
          if (this.orderInfo.buyerRefundStatus == 1) {
            str = "订单已申请退货";
          }
          if (this.orderInfo.buyerRefundStatus != 0) {
            str = "订单已经退货";
          }
          if (str) {
            this.$dialog.alert({ title: str }).then((x) => {
              this.$router.back(-1);
            });
          }

          this.companyorder = JSON.parse(JSON.stringify(this.orderInfo));
          this.orderInfo.tradeDetails.forEach((x) => {
            //设置公司数量为0
            this.$set(x, "num2", 0);
          });
          //把明细处理掉
          this.$set(this.companyorder, "isToCompany", true);

          this.companyorder.tradeDetails = [];
          if (this.orderInfo.isDisableSelfShip) {
            this.ordertoCompany();
          }
        });
    },
    goto(item) {
      var productsku = item.productSku;
      this.$router.push({
        path: "/product/" + productsku,
      });
    },
    //订单全部转公司
    ordertoCompany() {
      this.orderInfo.tradeDetails.forEach((x) => {
        let mm = JSON.parse(JSON.stringify(x));
        mm.num2 = 0;
        x.num2=x.num;
        this.companyorder.tradeDetails.push(mm);
      });
      this.getchangeprice();
    },
    onConfirm(value, index) {
      //进行转单
      //进行转单
      //检查所在位置 并设置公司数量

      var mm;
      this.orderInfo.tradeDetails.forEach((x) => {
        if (x.productSpecId == this.curitem.productSpecId) {
          mm = JSON.parse(JSON.stringify(x));
          mm.num2 = 0;
          mm.num = value;
          this.$set(x, "num2", value);
        }
      });
      //检索公司明细 过滤掉这个记录 再新增记录
      var curdetail = this.companyorder.tradeDetails.filter(
        (x) => x.productSpecId != this.curitem.productSpecId
      );
      curdetail.push(mm);
      this.companyorder.tradeDetails = curdetail;

      //打印公司订单
      console.log(this.companyorder);
      this.showPicker = false;
      this.getchangeprice();

      //检索价格
      //SetTranferOrderToTalPrice
    },
    setorder() {
      this.tranfereditdto.tid = this.tid;
      this.tranfereditdto.tranferOrderList = [];
      var curdto = JSON.parse(JSON.stringify(this.orderInfo));
      curdto.tradeDetails = curdto.tradeDetails.filter((x) => x.num - x.num2 > 0);
      if (curdto.tradeDetails.length > 0) {
        this.tranfereditdto.tranferOrderList.push(curdto);
      }
      if (this.companyorder.tradeDetails.length > 0) {
        this.tranfereditdto.tranferOrderList.push(this.companyorder);
      }
    },
    getchangeprice() {
      this.setorder();
      request
        .post(
          "/api/services/app/PhoneTrade/SetTranferOrderToTalPrice",
          this.tranfereditdto
        )
        .then((x) => {
          this.bigmoney = 0;
          this.assestmoney = 0;
          this.postFee = 0;
          x.result.tranferOrderList.forEach((y) => {
            this.bigmoney += y.bigMoney;
            this.assestmoney += y.assistMoney;
            //this.postFee = y.postFee;
            if(y.isToCompany)
            {
              this.postFee = y.postFee;
            }
          });
        });
    },
    //取消转给公司
    cancelnum(item) {
      this.orderInfo.tradeDetails.forEach((x) => {
        if (x.productSpecId == item.productSpecId) {
          this.$set(x, "num2", 0);
          this.$set(x, "cartontexts", undefined);
        }
      });
      var curdetail = this.companyorder.tradeDetails.filter(
        (x) => x.productSpecId != item.productSpecId
      );
      console.log();
      this.companyorder.tradeDetails = curdetail;
      this.getchangeprice();
      console.log(this.companyorder);
    },
    tranfer() {
      //弹出显示框是否要转单accessoriesLoans

      if (abp.userInfo.accessoriesLoans < this.assestmoney) {
        this.$toast("物料余额不足");
        return;
      }

      if (abp.userInfo.largeLoans < this.bigmoney) {
        this.$toast("大货余额不足");
        return;
      }

      this.setorder();

      this.dialogshow = true;
      //请求后台开始创建
    },
    ordertranfer() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "创建中",
      });
      //需使用推送
      request
        .post("/api/services/app/PhoneTrade/CraeteTranferOrder", this.tranfereditdto)
        .then((x) => {
          // x.result.tranferOrderList.forEach(y=>
          // {
          //     this.bigmoney=y.bigMoney;
          //     this.assestmoney=y.assistMoney;
          // })
          Toast.clear();

          var tid = x.result;
          if (tid) {
            this.$router.push({
              path: "/pay",
              query: {
                tid: tid,
                code: "",
              },
            });
          } else {
            this.$router.back(-1);
          }
        })
        .finally(() => {
          Toast.clear();
        });
    },
    trancompany(item) {
      this.curitem = item;
      //(product.productInfo.productType==0&&product.cartonSizeList&&product.cartonSizeList.length>0)||product.productInfo.productType==1
      if (item.cartonSizeList != null && item.cartonSizeList.length > 0) {
        this.treelist = item.cartonSizeList;
        this.totalnum = item.num;
        this.activeids = [];
        if (item.activeids) {
          this.activeids = item.activeids;
        }
        this.checknum();

        this.showtree = true;
      } else {
        this.columns = item.listNum;
        this.showPicker = true;
      }
      // if(item.productInfo.listNum&&item.productInfo.listNum.length>0)
      // {
      //     this.columns=item.listNum;
      //     this.showPicker=true;
      // }
    },
    cartoncancel() {
      this.showtree = false;
    },
    setcartonsize() {
      console.log("规格:", this.curwz);
      this.orderInfo.tradeDetails.forEach((x) => {
        if (x.productSpecId == this.curitem.productSpecId) {
          this.$set(x, "cartontexts", this.curwz);
          this.$set(x, "num2", this.curnum);
          this.$set(x, "activeids", this.activeids);
        }
      });
      console.log(this.orderInfo);
      //过滤所有箱规选项
      var curdetail = this.companyorder.tradeDetails.filter(
        (x) => x.productSpecId != this.curitem.productSpecId
      );
      //增加当前的箱规进去

      curdetail = curdetail.concat(this.curcheck);
      this.companyorder.tradeDetails = curdetail;
      this.showtree = false;
      this.getchangeprice();
    },
    checknum() {
      console.log("选中过的东西", this.activeids);
      //设置所有能点击和不能点击的
      //获取总数量 跟总数量比较 并禁用一些超出数量的按钮 每个右侧只能选中一个 选中后禁用全部 除了它自己
      this.curnum = 0;
      var yindex = []; //子数组Id
      this.curwz = [];
      this.curcheck = [];
      var mm = this.curitem;
      this.activeids.forEach((x) => {
        var arr = x.split("_");
        var index1 = arr[0]; //索引指向
        var index2 = arr[1]; //索引
        var tree1 = this.treelist[index1];
        var tree2 = tree1.children[index2];
        yindex.push(tree2.id);
        var num1 = tree1.num;
        var num2 = tree2.num;
        this.curwz.push({ text: num1 + this.curitem.unit + "/箱", num: num2 }); //要显示的文字
        //选中的箱规
        var m1 = JSON.parse(JSON.stringify(mm));
        m1.cartonSize = num1;
        m1.num = num2;
        m1.num2 = 0;
        this.curcheck.push(m1);
        console.log("选中:", num1 * num2);
        this.curnum += num1 * num2;
      });

      console.log("选中总数量:", this.curnum);
      var synum = this.totalnum - this.curnum; //剩余数量
      console.log("打印右侧选中索引", yindex);
      //开始禁用按钮
      this.treelist.forEach((x) => {
        //如果已经有选中的该列表所有都无法使用
        var setalldisabled = false; //除了选中项
        if (x.children.filter((z) => yindex.includes(z.id)).length > 0) {
          setalldisabled = true;
        }
        x.children.forEach((y) => {
          //去除数量不足的
          if (synum >= x.num * y.num) {
            this.$set(y, "disabled", false);
          } else {
            this.$set(y, "disabled", true);
          }
          //有选中项的
          if (setalldisabled) {
            this.$set(y, "disabled", true);
          }
          //去除选中项
          if (yindex.includes(y.id)) {
            this.$set(y, "disabled", false);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.omain {
  position: relative;
  margin: 10px;
  font-size: 14px;
}

.info {
  border-radius: 4px;
  box-shadow: 1px 1px 4px #dcdcdc;
  
}
.newinfo{
  margin-bottom: 50px;
}

.info-logistic {
  position: relative;
  padding: 0 20px 0 40px;
}

.info-address {
  position: relative;
  padding: 0 20px 0 40px;
}

.info-icon {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.info-logistic-icon-right {
  right: 0;
}

.info-logistic-icon-left {
  left: 0;
}

.currow {
  padding: 10px 16px;
  font-size: 14px;
}

.curcol {
  text-align: right;
  color: red;
}

.logistics {
  margin-top: 15px;
}

.logistics i {
  line-height: 60px;
  font-size: 20px;
}

.van-cell__title span {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.van-cell__label {
  color: #999;
}

.total {
  font-size: 12px;
}

.total .van-cell__value {
  color: red;
}

.footer {
  position: fixed;
  left: 10px;
  right: 10px;
  border-top: 1px solid #e5e5e5;
  bottom: 0;
  background: #fff;
  line-height: 24px;
  text-align: right;
  padding: 10px 0;
}

.van-button {
  padding: 0px 14px 0 14px;
  height: 28px;
  margin-right: 10px;
}

.comcard {
  background-color: white;
  margin-bottom: 10px;
}
.comcardinfo {
  position: relative;
  padding-left: 110px;
}
.comimg {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  width: 100px;
  height: 100px;
}
.clearboth {
  clear: both;
}
.comimg img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.comproduct {
  min-height: 100px;
  font-size: 12px;
}
.com-header {
  padding-right: 66px;
  position: relative;
  font-size: 15px;
  margin-bottom: 5px;
}
.com-header-left {
  word-break: break-all;
}
.com-header-right {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 14px;
}
.com-left {
  float: left;
}
.com-right {
  float: right;
}
.com-main {
  color: #a7a7a7;
  margin-bottom: 5px;
}
.com-main-sbg {
  padding: 2px 6px;
  border-radius: 999px;
  background-color: #eee;
}

.specbtns {
  margin-top: 5px;
}
.xg {
  background-color: deepskyblue;
  color: white;
}
.zten {
  text-align: center;
}
.ztop {
  border-bottom: 1px solid #e5e5e5;
}
.btns {
  margin-top: 10px;
  text-align: left;
}
.btn-fr {
  float: right;
}

.ztit {
  text-align: center;
}
.zproduct {
  padding: 5px 10px 5px 10px;
}

.ztname {
  display: inline-block;
  width: 60%;
  text-align: left;
  word-break: break-all;
}
.zfr {
  display: inline-block;
  width: 40%;
  text-align: right;
}
.ztotal {
  text-align: right;
  font-size: 12px;
}
.zprice {
  color: red;
}
</style>
